export const muhendislikInsaatPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Mühendislik ve İnşaat Sigortaları</h1>
        <p class="page-subtitle">İnşaat projelerinizi, montaj işlerinizi ve makinelerinizi kapsamlı sigorta teminatları ile güvence altına alıyoruz.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><rect x="1" y="6" width="22" height="15" rx="2"></rect><path d="M1 10h22"></path><path d="M6 6V3"></path><path d="M18 6V3"></path></svg>
          </div>
          <div class="service-info">
            <h3>İnşaat All Risk Sigortası</h3>
            <p>İnşaat sürecinde oluşabilecek her türlü hasar ve kayba karşı kapsamlı güvence sağlar. Doğal afetler, hırsızlık, iş kazaları ve üçüncü şahıs sorumlulukları dahildir.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Montaj Sigortası</h3>
            <p>Makine ve ekipman montajı sırasında meydana gelebilecek hasar ve kayıpları karşılar. Montaj süreci boyunca malzeme, işçilik ve nakliye riskleri teminat altındadır.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Makine Kırılması Sigortası</h3>
            <p>İşletmenizdeki makine ve ekipmanları ani ve beklenmedik arızalara karşı korur. Elektrik hasarı, operatör hatası, malzeme yorgunluğu gibi riskleri kapsar.</p>
          </div>
        </div>
      </div>

      <div class="service-cta">
        <h2>Projelerinizi Güvence Altına Alın</h2>
        <p>İnşaat ve mühendislik sigortaları hakkında detaylı bilgi ve teklif almak için bize ulaşın.</p>
        <a href="/teklif-al" class="btn-primary">Hemen Teklif Al</a>
      </div>
    </div>
  </section>
`;
